<script lang="ts">
import {CheckCircleSolid} from "flowbite-svelte-icons";
import {Button} from "flowbite-svelte";
import type {Writable} from "svelte/store";
import {getContext} from "svelte";
import {globalToast} from "$lib/stores/toast";

let super_edit: Writable<boolean> = getContext('super_edit');
const onSubmit = (ev: PointerEvent) => {
    const form = ev.srcElement.closest('form');
    console.log({form})
    if(form.checkValidity()){
        setTimeout(() => {
            $super_edit = false;
            $globalToast.timed('Saved')
        }, 500)
    }


}
</script>

{#if $super_edit}
    <div class="grid place-items-end my-3">
        <Button size="xs" class="!p-2" pill type="submit" on:click={ev => onSubmit(ev)}>
            <CheckCircleSolid class="w-4 h-4"/>
        </Button>
    </div>
{/if}
